export const isValidURL = (url = '') => {
  const pattern = new RegExp(
    '^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.,~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$', // fragment locator
    'i'
  )

  return !!pattern.test(url)
}

// Returns the value only if it is a safe http(s) URL, otherwise null. Use this to
// guard any user-/SCIM-sourced string before placing it in an `href` — it blocks
// dangerous schemes like `javascript:` and `data:` (XSS defense-in-depth).
export const safeHttpUrl = (
  value: string | null | undefined
): string | null => {
  if (!value) return null
  try {
    const url = new URL(value)

    return url.protocol === 'https:' || url.protocol === 'http:' ? value : null
  } catch {
    return null
  }
}

// Stricter check for validating the LinkedIn input before saving: must be an
// http(s) URL on the linkedin.com domain.
export const isValidLinkedInUrl = (value: string): boolean => {
  try {
    const url = new URL(value)

    return (
      (url.protocol === 'https:' || url.protocol === 'http:') &&
      /(^|\.)linkedin\.com$/i.test(url.hostname)
    )
  } catch {
    return false
  }
}
